import type { CheckoutPayload, CreateOrderRequest } from '../types/api';
import type { IyzicoOrderRequest } from '../types/payment';

function mapOrderAddressFields(
  order: Pick<
    IyzicoOrderRequest,
    | 'shippingAddressId'
    | 'shippingAddress'
    | 'billingSameAsShipping'
    | 'billingAddressId'
    | 'billingAddress'
    | 'saveShippingAddress'
    | 'saveBillingAddress'
  >,
) {
  return {
    shippingAddressId: order.shippingAddressId ?? null,
    shippingAddress: order.shippingAddress,
    billingSameAsShipping: order.billingSameAsShipping ?? true,
    billingAddressId: order.billingAddressId ?? null,
    billingAddress: order.billingAddress,
    saveShippingAddress: order.saveShippingAddress ?? false,
    saveBillingAddress: order.saveBillingAddress ?? false,
  };
}

export function buildCreateOrderRequest(payload: CheckoutPayload): CreateOrderRequest {
  const nameParts = payload.contact.name.trim().split(/\s+/);

  return {
    items: payload.items.map(({ productId, quantity, price }) => ({
      productId,
      quantity,
      price,
    })),
    subtotal: payload.subtotal,
    discountAmount: payload.discountAmount,
    couponCode: payload.couponCode ?? null,
    shipping: payload.shipping,
    total: payload.total,
    currency: payload.currency,
    shippingAddressId: payload.shippingAddressId ?? null,
    shippingAddress: payload.shippingAddress,
    billingSameAsShipping: payload.billingSameAsShipping ?? true,
    billingAddressId: payload.billingAddressId ?? null,
    billingAddress: payload.billingAddress,
    saveShippingAddress: payload.saveShippingAddress ?? false,
    saveBillingAddress: payload.saveBillingAddress ?? false,
    contact: {
      firstName: nameParts[0] ?? '',
      lastName: nameParts.slice(1).join(' '),
      email: payload.contact.email,
      phone: payload.contact.phone,
    },
    consents: payload.consents,
  };
}

export function buildCreateOrderRequestFromIyzico(order: IyzicoOrderRequest): CreateOrderRequest {
  return {
    items: order.items,
    subtotal: order.subtotal,
    discountAmount: order.discountAmount,
    couponCode: order.couponCode ?? null,
    shipping: order.shipping,
    total: order.total,
    currency: order.currency,
    ...mapOrderAddressFields(order),
    contact: order.contact,
    consents: order.consents,
  };
}
